export default "__VITE_ASSET__Dk1UI6xR__"